export class TechnicalError extends Error {}
